import { useCallback } from "react"
import { useAppDispatch, useAppSelector } from "./redux/hooks"
import { ChaingeChain, ChaingeTokenChain } from "types/baseType"
import { setChainsForTokenFrom, setChainsForTokenTo } from "./redux/slices/appSlice"

const useChainsForToken = () => {
    const { chains } = useAppSelector((state) => state.app)
    const dispatch = useAppDispatch()

    const chainsByToken = useCallback((token: ChaingeTokenChain, direction: string, otherChains?: ChaingeChain[]) => {
        if(!(otherChains && otherChains.length)) {
            otherChains = chains
        }
        const chainNameList = token.chainList || []
        const chainList: ChaingeChain[] = []
        chainNameList.forEach(chainName => {
            const chain = (otherChains as ChaingeChain[]).find(item => item.nickName === chainName)
            if(chain) {
                chainList.push(chain)
            }
        } )
        if(direction === 'from') {
            dispatch(setChainsForTokenFrom(chainList))
        } else {
            dispatch(setChainsForTokenTo(chainList))
        }
    }, [chains, dispatch])

    return {chainsByToken}
}

export default useChainsForToken